<template>
	<v-dialog
		v-model="dialog"
		:width="dialogWidth"
	>
		<template #activator="{ props }">
			<v-btn
				v-bind="props"
			>
				<v-icon
					v-if="prependIcon"
					style="padding-right: 5px"
					:icon="prependIcon"
				/>
				{{ label }}
			</v-btn>
		</template>
		<v-card>
			<v-card-title>
				<slot name="title" />
			</v-card-title>
			<v-card-text>
				<slot />
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					variant="text"
					@click="dialog = false"
				>
					Close
				</v-btn>
				<slot name="actions" />
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DialogButton',
	props: {
		label: {
			type: String,
			required: false,
			default: 'Info',
		},
		prependIcon: {
			type: String,
			required: false,
			default: null,
		},
		dialogWidth: {
			type: Number,
			required: false,
			default: 500
		}
	},

	data () {
		return {
			dialog: false,
		};
	},
};
</script>
